import React, { useState, useEffect, useRef } from "react";
import { downloadCsv } from "../common/sharedFunctions";
import MaterialTable from "material-table";
import { useSelector } from "react-redux";
import CircularLoading from "../components/CircularLoading";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { Typography, Button } from "@mui/material";
import moment from "moment/min/moment-with-locales";
import { MAIN_COLOR, SECONDORY_COLOR } from "../common/sharedFunctions";
import { colors } from "../components/Theme/WebTheme";

export default function UserRides({ data, tabid }) {
  const { id } = useParams();
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir();
  const bookinglistdata = useSelector((state) => state.bookinglistdata);
  const settings = useSelector((state) => state.settingsdata.settings);
  const loaded = useRef(false);
  const [bookingData, setBookingData] = useState([]);
  const navigate = useNavigate();
  const [selectedRow, setSelectedRow] = useState(null);

  useEffect(() => {
    if (bookinglistdata.bookings) {

      if (data.usertype === "customer") {
        setBookingData(
          bookinglistdata.bookings.filter((item) => item.customer === id)
        );
      }
      else if (data.usertype === "driver") {
        setBookingData(
          bookinglistdata.bookings.filter((item) => item.driver === id)
        );
      }

    } else {
      setBookingData([]);
    }
    loaded.current = true;


  }, [bookinglistdata.bookings, id, data]);

  const col = [
    {
      title: t("booking_status"),
      field: "status",
      render: (rowData) => {
        const statusColors = {
          CANCELLED: "linear-gradient(135deg, #ef4444 0%, #dc2626 100%)",
          COMPLETE: "linear-gradient(135deg, #10b981 0%, #059669 100%)",
          ACCEPTED: "linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)",
          NEW: "linear-gradient(135deg, #f59e0b 0%, #d97706 100%)",
          PAID: "linear-gradient(135deg, #f97316 0%, #ea580c 100%)",
          ARRIVED: "linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)",
          STARTED: "linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)",
        };
        const bg = statusColors[rowData.status] || "linear-gradient(135deg, #6b7280 0%, #4b5563 100%)";
        return (
          <div
            style={{
              background: bg,
              color: "white",
              padding: "6px 12px",
              borderRadius: "20px",
              fontWeight: "600",
              width: "120px",
              margin: "auto",
              textAlign: "center",
              fontSize: "12px",
              boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
            }}
          >
            {t(rowData.status)}
          </div>
        );
      },
    },
    {
      title: t("booking_ref"),
      field: "reference",
      cellStyle: {
        textAlign: "center",
        borderBottom: "1px solid #f3f4f6",
        padding: "12px",
      },
    },
    {
      title: t("booking_date"),
      field: "bookingDate",
      render: (rowData) =>
        rowData.bookingDate ? moment(rowData.bookingDate).format("lll") : null,
      cellStyle: {
        textAlign: "center",
        borderBottom: "1px solid #f3f4f6",
        padding: "12px",
      },
    },
    {
      title: t("pickup_address"),
      field: "pickupAddress",
      cellStyle: {
        textAlign: "center",
        borderBottom: "1px solid #f3f4f6",
        padding: "12px",
      },
    },
    {
      title: t("drop_address"),
      field: "dropAddress",
      cellStyle: {
        textAlign: "center",
        borderBottom: "1px solid #f3f4f6",
        padding: "12px",
      },
    },
  ];

  return !loaded.current ? (
    <CircularLoading />
  ) : (
    <>
      <div
        style={{
          backgroundColor: colors.LandingPage_Background,
          borderRadius: 10,
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        <div
          dir={isRTL === "rtl" ? "rtl" : "ltr"}
        >
          <Button
            variant="text"
            onClick={() => {
              navigate(`/users/${tabid}`);
            }}
          >
            <Typography
              style={{
                textAlign: isRTL === "rtl" ? "right" : "left",
                fontWeight: "bold",
                color: MAIN_COLOR,
              }}
            >
              {`<<- ${t("go_back")}`}
            </Typography>
          </Button>
        </div>
        <MaterialTable
          title={t("bookings_table_title")}
          columns={col}
          style={{
            direction: isRTL === "rtl" ? "rtl" : "ltr",
            borderRadius: "12px",
            boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
            border: "none",
            width: "100%",
            padding: "20px"
          }}
          data={bookingData}
          onRowClick={(evt, selectedRow) =>
            setSelectedRow(selectedRow.tableData.id)
          }
          options={{
            pageSize: 10,
            pageSizeOptions: [10, 15, 20],
            exportCsv: (columns, data) => {
              let hArray = [];
              const headerRow = columns.map((col) => {
                if (typeof col.title === "object") {
                  return col.title.props.text;
                }
                hArray.push(col.field);
                return col.title;
              });
              const dataRows = data.map(({ tableData, ...row }) => {
                row.createdAt =
                  new Date(row.createdAt).toLocaleDateString() +
                  " " +
                  new Date(row.createdAt).toLocaleTimeString();
                let dArr = [];
                for (let i = 0; i < hArray.length; i++) {
                  dArr.push(row[hArray[i]]);
                }
                return Object.values(dArr);
              });
              const { exportDelimiter } = ",";
              const delimiter = exportDelimiter ? exportDelimiter : ",";
              const csvContent = [headerRow, ...dataRows]
                .map((e) => e.join(delimiter))
                .join("\n");
              const csvFileName = "download.csv";
              downloadCsv(csvContent, csvFileName);
            },
            exportButton: {
              csv: settings.AllowCriticalEditsAdmin,
              pdf: false,
            },
            maxColumnSort: "all_columns",
            rowStyle: (rowData) => ({
              backgroundColor:
                selectedRow === rowData.tableData.id ? "#f3f4f6" : "#FFF",
              borderBottom: "1px solid #f3f4f6",
              fontSize: "14px",
              color: "#374151"
            }),
            editable: {
              backgroundColor: colors.Header_Text,
              fontSize: "0.8em",
              fontWeight: "bold ",
              fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
            },
            headerStyle: {
              position: "sticky",
              top: "0px",
              background: 'linear-gradient(135deg, #487FFF 0%, #3598db 100%)',
              color: '#fff',
              textAlign: "center",
              fontWeight: "600",
              fontFamily: 'Inter, sans-serif',
              border: "none",
              height: "50px",
            },
            cellStyle: {
              borderBottom: "1px solid #f3f4f6",
              textAlign: "center",
              padding: "12px",
            },
            actionsColumnIndex: -1,
          }}
          localization={{
            body: {
              addTooltip: t("add"),
              deleteTooltip: t("delete"),
              editTooltip: t("edit"),
              emptyDataSourceMessage: t("blank_message"),
              editRow: {
                deleteText: t("delete_message"),
                cancelTooltip: t("cancel"),
                saveTooltip: t("save"),
              },
            },
            toolbar: {
              searchPlaceholder: t("search"),
              exportTitle: t("export"),
            },
            header: {
              actions: t("actions"),
            },
            pagination: {
              labelDisplayedRows: "{from}-{to} " + t("of") + " {count}",
              firstTooltip: t("first_page_tooltip"),
              previousTooltip: t("previous_page_tooltip"),
              nextTooltip: t("next_page_tooltip"),
              lastTooltip: t("last_page_tooltip"),
            },
          }}
        />
      </div>
    </>
  );
}
